var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNohardCopy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 76,
    rx: 8,
    fill: "#FCEBE3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21.0088,
    y: 20.8111,
    width: 27.3623,
    height: 36.1889,
    rx: 1.76531,
    fill: "#F78670"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.307 30.363H45.2362C45.7342 30.363 46.1428 29.9544 46.1428 29.4564C46.1428 28.9585 45.7342 28.5499 45.2362 28.5499H37.307C36.809 28.5499 36.4004 28.9585 36.4004 29.4564C36.4004 29.9544 36.809 30.363 37.307 30.363Z",
    fill: "#02475E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.307 35.6503H45.2362C45.7342 35.6503 46.1428 35.2417 46.1428 34.7437C46.1428 34.2458 45.7342 33.8372 45.2362 33.8372H37.307C36.809 33.8372 36.4004 34.2458 36.4004 34.7437C36.4004 35.2545 36.809 35.6503 37.307 35.6503Z",
    fill: "#02475E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2498 39.1348H26.6204C26.1225 39.1348 25.7139 39.5434 25.7139 40.0414C25.7139 40.5394 26.1225 40.948 26.6204 40.948H45.2498C45.7477 40.948 46.1563 40.5394 46.1563 40.0414C46.1436 39.5434 45.7477 39.1348 45.2498 39.1348Z",
    fill: "#02475E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2498 44.4342H26.6204C26.1225 44.4342 25.7139 44.8428 25.7139 45.3408C25.7139 45.8387 26.1225 46.2473 26.6204 46.2473H45.2498C45.7477 46.2473 46.1563 45.8387 46.1563 45.3408C46.1563 44.8428 45.7477 44.4342 45.2498 44.4342Z",
    fill: "#02475E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0907 49.7216H26.6204C26.1225 49.7216 25.7139 50.1302 25.7139 50.6281C25.7139 51.1261 26.1225 51.5347 26.6204 51.5347H37.0907C37.5886 51.5347 37.9972 51.1261 37.9972 50.6281C37.9972 50.1302 37.5886 49.7216 37.0907 49.7216Z",
    fill: "#02475E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5443 26.0691C52.1047 26.0691 54.991 23.1828 54.991 19.6224C54.991 16.0621 52.1047 13.1758 48.5443 13.1758C44.9839 13.1758 42.0977 16.0621 42.0977 19.6224C42.0977 23.1828 44.9839 26.0691 48.5443 26.0691Z",
    fill: "#02475E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1976 16.985L45.8906 22.2751",
    stroke: "#F78670",
    strokeWidth: 1.78097,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1976 22.2751L45.8906 16.985",
    stroke: "#F78670",
    strokeWidth: 1.78097,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24.9805,
    y: 26.5484,
    width: 7.9439,
    height: 7.9439,
    fill: "#02475E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNohardCopy);
export default __webpack_public_path__ + "static/media/NohardCopy.168370c3fbe8e724837605ea9805676e.svg";
export { ForwardRef as ReactComponent };